// extracted by mini-css-extract-plugin
module.exports = {"Submission":"Submission_Submission__2DSkB"};